import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PAYMENT: AppRouteRecordRaw = {
  path: '/payment',
  name: 'Payment',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.payment',
    requiresAuth: true,
    icon: 'icon-alipay-circle',
    order: 2,
  },
  children: [
    {
      path: 'list',
      name: 'PaymentList',
      component: () => import('@/views/payment/list/index.vue'),
      meta: {
        locale: 'menu.payment.list',
        requiresAuth: true,
        roles: ['admin', 'user', 'superAdmin'],
      },
    },
    {
      path: 'edit/:id?',
      name: 'PaymentEdit',
      component: () => import('@/views/payment/edit/index.vue'),
      meta: {
        locale: 'menu.payment.edit',
        requiresAuth: true,
        roles: ['admin', 'user', 'superAdmin'],
        hideInMenu: true,
      },
    },
    {
      path: 'store-config',
      name: 'StoreConfig',
      component: () => import('@/views/payment/store-config/index.vue'),
      meta: {
        locale: 'menu.payment.storeConfig',
        requiresAuth: true,
        roles: ['admin', 'user', 'superAdmin'],
      },
    },
    {
      path: 'gateway',
      name: 'PaymentGateway',
      component: () => import('@/views/payment/gateway/index.vue'),
      meta: {
        locale: 'menu.payment.gateway',
        requiresAuth: true,
        roles: ['admin', 'user', 'superAdmin'],
      },
    },
  ],
};

export default PAYMENT;
